export default {"src":"/_next/static/media/partner26.db260332.svg","height":70,"width":123,"blurWidth":0,"blurHeight":0};